import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon, SweetAlertOptions } from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  error(message: string, icon: SweetAlertIcon = 'error' ){
    Swal.fire({
      title: 'La Colonial',
      html: message,
      icon
    })
  }

  blocked(message: string){
    return Swal.fire({
      title: 'La Colonial',
      html: message,
      icon: 'error',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Ok'
    })
  }

  confirm(message: string, title?: string){
    return Swal.fire({
      title: title,
      html: message,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar'
    })
  }

  showLoading(message?: string){
    Swal.fire({
      html: `
        <div style="position: absolute; width: 96px; height: 96px; margin: auto; left: 0; right: 0; top: 0; bottom: 0;">
          <div style="position:absolute;top:0;left:0;width:96px;height:96px;border-radius:50%;border:3px solid rgba(154,5,19,0.12);border-top-color:#9a0513;animation:colonial-spin 0.85s linear infinite;box-sizing:border-box;"></div>
          <img src="assets/img/nav/LOGO.svg" alt="La Colonial" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:48px;height:48px;object-fit:contain;" />
        </div>
        ${message ? `<p style="margin:0;font-size:0.9rem;color:#6c757d;">${message}</p>` : ''}
      `,
      allowOutsideClick: false,
      showConfirmButton: false,
      showClass: { popup: 'swal2-show', backdrop: 'swal2-backdrop-show', icon: '' },
      hideClass: { popup: 'swal2-hide', backdrop: 'swal2-backdrop-hide', icon: '' },
    })
  }

  success(message?: string, options?: SweetAlertOptions){
    return Swal.fire({
      html: message,
      icon: 'success',
      didOpen() {
        Swal.hideLoading()
      },
      ...options
    })
  }

  notification(message: string, large = false) {
    const fontSize = large ? '1.2rem' : '0.95rem';
    return Swal.fire({
      html: `<p style="font-size:${fontSize};margin:0;">${message}</p>`,
      confirmButtonText: 'Continuar',
      confirmButtonColor: '#9a0513',
      showClass: { popup: 'swal2-show', backdrop: 'swal2-backdrop-show', icon: '' },
      hideClass: { popup: 'swal2-hide', backdrop: 'swal2-backdrop-hide', icon: '' },
    });
  }

  fieldsRequired(fields: string[]) {
    const items = fields
      .map(f => `<li style="display:flex;align-items:center;gap:8px;padding:6px 0;border-bottom:1px solid #f3f3f3;">
        <span style="width:8px;height:8px;border-radius:50%;background:#9a0513;flex-shrink:0;"></span>
        <span style="font-size:0.95rem;">${f}</span>
      </li>`)
      .join('');
    return Swal.fire({
      html: `
        <p style="font-weight:600;margin-bottom:12px;font-size:1rem;">Datos requeridos</p>
        <ul style="list-style:none;padding:0;margin:0;text-align:left;">${items}</ul>
      `,
      confirmButtonText: 'Continuar',
      confirmButtonColor: '#9a0513',
      showClass: { popup: 'swal2-show', backdrop: 'swal2-backdrop-show', icon: '' },
      hideClass: { popup: 'swal2-hide', backdrop: 'swal2-backdrop-hide', icon: '' },
    });
  }

  dismiss(){
    Swal.close()
  }
}
